import Icon from "../../icon";
import "./styles.scss";
export default function info (props) {
    return (
        <Icon id="info" className={"info"} />
    )
}